module.exports = __webpack_public_path__ + "images/emoji/end.d92943827939d60c0025.png";